import { storeToRefs } from 'pinia'

import { useStoreSettingsForwarding } from '@/entities/forwarding'
import { useStoreSettingsNotifications } from '@/entities/notification'
import { useQueueServiceStore } from '@/entities/queue-service'

export const useSetStatusHook = () => {
  const storeSettingsForwarding = useStoreSettingsForwarding()
  const { saveForwarding, loadAllForwardings, loadSubscriberServices } = storeSettingsForwarding
  const { dndForward } = storeToRefs(storeSettingsForwarding)
  const storeSettingsNotifications = useStoreSettingsNotifications()
  const queueServiceStore = useQueueServiceStore()

  const init = () => {
    return Promise.all([
      loadAllForwardings(),
      loadSubscriberServices(),
      queueServiceStore.fetchAll(),
    ])
  }

  const setUpdateDNDonSetStatus = (status: number) => {
    if (!dndForward.value || !storeSettingsNotifications.isDndAutoActivate) return

    const dndWasNotEnabledBefore = !JSON.parse(localStorage.getItem('DND') ?? 'false')
    const enabled = status === 3
    const dndIsNotTheSame = enabled !== dndForward.value.enabled

    if (dndWasNotEnabledBefore && dndIsNotTheSame) {
      saveForwarding({
        ...dndForward.value,
        enabled,
      }).then(() => {
        // TODO move this mutation to store action
        if (dndForward.value) {
          dndForward.value.enabled = enabled
        }
      })
    }
  }

  const disableDndOnAutoActivateOff = () => {
    if (!dndForward.value?.enabled) return

    saveForwarding({
      ...dndForward.value,
      enabled: false,
    }).then(() => {
      if (dndForward.value) {
        dndForward.value.enabled = false
      }
    })
  }

  return {
    init,
    setUpdateDNDonSetStatus,
    disableDndOnAutoActivateOff,
  }
}
